/**
 * Coverage card — [BUT-843, ours]. Desktop has no COVERED-state
 * Figma frame at all (mobile has a green-gradient package card at
 * `14621:527978`), so this is a plain card in the portal's own idiom rather
 * than a port of mobile's gradient card to a 1920-wide layout it was never
 * drawn for.
 *
 * Purely presentational — the four coverage renders (full / unlimited /
 * partial / none) are decided by the caller (`LessonPaymentStep`, step 13)
 * and passed in as `copy`. No domain branching inside this shared piece.
 *
 * MINUTES only, never a currency amount — the instructor rate is not on the
 * wire and no client computes a booking price.
 *
 * @module pages/lessons/components/LessonCoverageCard
 */

import type { ReactNode } from 'react';
import { PackageIcon } from '@butter/ui/icons';

export interface LessonCoverageCardProps {
  packName: string;
  balanceLabel: string;
  copy: ReactNode;
  className?: string;
}

export function LessonCoverageCard({ packName, balanceLabel, copy, className }: LessonCoverageCardProps) {
  return (
    <div
      className={`rounded-28 border-1.25 border-theme-100 bg-theme-25 p-7${className ? ` ${className}` : ''}`}
      data-testid="lesson-coverage-card"
    >
      <div className="flex items-center gap-3">
        <PackageIcon className="size-6 text-theme-600" />
        <span className="text-lg font-semibold text-fg-primary">{packName}</span>
      </div>
      <p className="mt-2 text-sm font-medium text-fg-quaternary">{balanceLabel}</p>
      <p className="mt-4 text-sm font-medium text-butter-gray-700">{copy}</p>
    </div>
  );
}
